import { render } from "./a-task-assigned-employee.vue?vue&type=template&id=e04c27ce"
import script from "./a-task-assigned-employee.vue?vue&type=script&lang=js"
export * from "./a-task-assigned-employee.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__